import { LLM_PATH } from './llm';

const ROOT_PATH = `${LLM_PATH}/shopping` as const;
export const ROOT = {
  PATH: ROOT_PATH,
  toPath: () => ROOT_PATH,
};
